import { DailyEdiCustomerLog } from "types/edi-dashboard";
import fetchWithRetry from "./fetch-retry";


export const listDailyEdiCustomerLog = async (fromDate: string, toDate: string, locationId?: number, ): Promise<DailyEdiCustomerLog[]> => 
    !!locationId
        ? await fetchWithRetry<DailyEdiCustomerLog[]>(
            `/api/edi-logs?locationId=${locationId}&fromDate=${fromDate}&toDate=${toDate}`,
            { method: 'GET' },
            []
        )
        : [];